import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { addSprint } from '../../../redux';
import NewQuestionForm from '../../Components/Question/NewQuestionForm';
import EditQuestionForm from '../../Components/Question/EditQuestionForm';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { Link, useNavigate } from 'react-router-dom';
import "./index.css";

function SprintForm (props) {
    const navigate = useNavigate();
    const [state, setState] = useState({
        name: "",
        questionAnswerTypePairs: [],
    });
    const [showNewQuestionForm, setShowNewQuestionForm] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const negotiateQuestions = () => {
        return [
          {
            id: "n1",
            question: "My negotiation partner was effective in building trust.",
            answer: "Range",
          },
          {
            id: "n2",
            question: "My negotiation partner was responsive to my emotions.",
            answer: "Range",
          },
          {
            id: "n3",
            question: "My negotiation partner was fair minded.",
            answer: "Range",
          },
          {
            id: "n4",
            question:
              "My negotiation partner was concerned with satisfying my interests.",
            answer: "Range",
          },
          {
            id: "n5",
            question:
              "My negotiation partner looked after his or her own interests.",
            answer: "Range",
          },
          {
            id: "n6",
            question: "My negotiation partner acted very competitively.",
            answer: "Range",
          },
          {
            id: "n7",
            question:
              "My negotiation partner was concerned with trying to create value and expand the pie.",
            answer: "Range",
          },
          {
            id: "n8",
            question: "My negotiation partner was effective overall.",
            answer: "Range",
          },
          {
            id: "n9",
            question: "I would like to negotiate with this person again.",
            answer: "Range",
          },
          {
            id: "n10",
            question: "I would like to negotiate with this person again.",
            answer: "Y/N",
          },
          {
            id: "n11",
            question:
              "What is one positive thing you noticed about your partner?",
            answer: "Text",
          },
          {
            id: "n12",
            question:
              "What is a second positive thing you noticed about your partner?",
            answer: "Text",
          },
          {
            id: "n13",
            question: "What is one improvement your partner could make?",
            answer: "Text",
          },
          {
            id: "n14",
            question: "What is a second improvement your partner could make?",
            answer: "Text",
          },
        ];
    }

    const teamQuestions = () => {
        return [
          {
            id: "t1",
            question: "This person encourages all team members to contribute.",
            answer: "Range",
          },
          {
            id: "t2",
            question:
              "This person helps to synthesize different points of view.",
            answer: "Range",
          },
          {
            id: "t3",
            question: "This person helps the team prioritize.",
            answer: "Range",
          },
          {
            id: "t4",
            question: "This person critiques others’ ideas respectfully.",
            answer: "Range",
          },
          {
            id: "t5",
            question: "This person helps the group clarify its goals.",
            answer: "Range",
          },
          {
            id: "t6",
            question:
              "This person makes others feel safe to bring up problems.",
            answer: "Range",
          },
          {
            id: "t7",
            question: "This person is someone I enjoy working with.",
            answer: "Range",
          },
          {
            id: "t8",
            question: "This person takes initiative.",
            answer: "Range",
          },
          {
            id: "t9",
            question: "I would like to work with this person again.",
            answer: "Range",
          },
          {
            id: "t10",
            question: "I would like to work with this person again",
            answer: "Y/N",
          },
          {
            id: "t11",
            question:
              "What is one positive thing you noticed about your teammate?",
            answer: "Text",
          },
          {
            id: "t12",
            question:
              "What is a second positive thing you noticed about your teammate?",
            answer: "Text",
          },
          {
            id: "t13",
            question: "What is one improvement your teammate could make?",
            answer: "Text",
          },
          {
            id: "t14",
            question: "What is a second improvement your teammate could make?",
            answer: "Text",
          },
          {
            id: "t15",
            question:
              "This person arrives to team meetings on time and prepared.",
            answer: "Range",
          },
          {
            id: "t16",
            question: "This person follows through on team assignments.",
            answer: "Range",
          },
          {
            id: "t17",
            question: "This person finishes his/her tasks on time.",
            answer: "Range",
          },
          {
            id: "t18",
            question: "This person executes his/her work at a high level.",
            answer: "Range",
          },
          {
            id: "t19",
            question: "This person completes his/her fair share of work.",
            answer: "Range",
          },
        ];
    }

    const removeQuestion = id => () => {
        const questionAnswerTypePairs = state.questionAnswerTypePairs.filter(q => {
            return q.id !== id
        });
        setState({
            ...state,
            questionAnswerTypePairs
        });
    }

    const editQuestion = id => (oldQuestionAnswer, newQuestionAnswer) => {
        const index = state.questionAnswerTypePairs.findIndex(
          (q) => q.id === id
        );
        const update = [...state.questionAnswerTypePairs];
        const {answer, question} = newQuestionAnswer
        update.splice(index, 1, {
          id,
          question,
          answer
        });
        setState({
          ...state,
          questionAnswerTypePairs: update,
        });
    }

    const getMappedQuestionsAnswerPairs = () => {
        return state.questionAnswerTypePairs.length !== 0
          ? state.questionAnswerTypePairs.map((q, index) => {
              return (
                <EditQuestionForm
                  key={`${index}-${q.id}`}
                  index={index + 1}
                  thisQuestionAnswer={q}
                  questionName={q.question}
                  questionAnswer={q.answer}
                  handleSubmit={editQuestion(q.id)}
                  handleDelete={removeQuestion(q.id)}
                />
              );
            })
          : null;
    }

    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const questionAnswerTypePairs = []
        let pointsForAssignment = 0;
        let pointsForDoingEvaluation = 0;
        for (let q of state.questionAnswerTypePairs) {
            const {answer, question} = q
            if (answer === "Text") {
                pointsForDoingEvaluation += 3
                questionAnswerTypePairs.push({question, answer, type: "Text"})
            } else {
                pointsForAssignment += 7
                questionAnswerTypePairs.push({question, answer, type: "Range"})
            }
        }
        props.addSprint(
            {
                name: state.name,
                questionAnswerTypePairs,
                pointsForAssignment,
                pointsForDoingEvaluation,
                class: props.classObject._id,
                status: "Active"
            },
            props.sprints
        );
        navigate("/teacher")
    }

    const openQuestionForm = () => {
        setShowNewQuestionForm(true)
    }

    const closeQuestionForm = () => {
        setShowNewQuestionForm(false)
    }

    function addNewQuestion (input) {
        const { answer, question } = input;
        const questionAnswerTypePairs = [
          ...state.questionAnswerTypePairs,
          {
            id: new Date().valueOf(),
            question,
            answer,
          },
        ];
        setState({
          ...state,
          questionAnswerTypePairs,
        });
    };

    const handleDropdownChange = (e) => {
        if (e.target.innerText.trim() === 'Peer Negotiation') {
            setState({
                ...state,
                questionAnswerTypePairs: negotiateQuestions(),
                preset: 'negotiate'
            });
        } else if (e.target.innerText.trim() === 'Peer Team') {
            setState({
                ...state,
                questionAnswerTypePairs: teamQuestions(),
                preset: 'peer'
            });
        } else {
            setState({
                ...state,
                questionAnswerTypePairs: [],
                preset: 'custom'
            });
        }
    }

    return (
        <div className="assignmentForm">
            <Link to="/teacher" className="backButton">
                <img src={require("../../../Images/leftArrow.png")} alt="<-"/>
                Return to Dashboard
            </Link>
            <h1>Create New Sprint</h1>
            <TextField
                hintText="Sprint Title"
                name="name"
                onChange={handleChange}
                value={state.name}
                style={{paddingTop: "0px", paddingBottom: "20px"}}
            />
            <br/>
            <SelectField
                hintText={"Presets"}
                name="questionTemplate"
                value={state.preset}
                onChange={handleDropdownChange}
                labelStyle={{textAlign: "left"}}
                floatingLabelStyle={{paddingLeft: "0%"}}
                style={{textAlign: "left"}}
            >
                <MenuItem
                    key="0Neg"
                    primaryText="Peer Negotiation"
                    value="negotiate"
                    id="negotiate"
                />
                <MenuItem
                    key="1Peer"
                    primaryText="Peer Team"
                    value="peer"
                    id="peer"
                />
                <MenuItem
                    key="2Custom"
                    primaryText="New/Custom"
                    value="custom"
                    id="custom"
                />
            </SelectField>
            <br/>
            {getMappedQuestionsAnswerPairs()}
            {showNewQuestionForm ?
                <NewQuestionForm
                    handleClick={closeQuestionForm}
                    addNewQuestion={addNewQuestion}
                />
                :
                <button className="actionButton addQuestion" onClick={openQuestionForm}>Add question</button>
            }
            <br/>
            <form onSubmit={handleSubmit}>
                <button type="submit" className="pink saveButton">Save</button>
            </form>
        </div>
    );
}

export default connect(state => state.root, { addSprint })(SprintForm);
